export default __webpack_public_path__ + "static/media/auditFilterIcon.40b34f81.svg";